import { Environment } from '../app/core/models/environment.model';

// eslint-disable-next-line import/no-unresolved
import { appConfig } from './app-config';

export const environment: Environment = {
  production: false,
  ...appConfig,
};
